import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number | string): string {
  const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(numericPrice);
}

export function getWhatsAppUrl(productName?: string, alternatePhone = false): string {
  const primary = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || '5493804306760';
  const secondary = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER_ALT || '5493804782360';
  const phone = alternatePhone ? secondary : primary;

  const text = productName
    ? `¡Hola Planeta Kaio! 🪐 Me interesa consultar por el producto: "${productName}". ¿Tienen stock disponible en sus sucursales de La Rioja?`
    : '¡Hola Planeta Kaio! 🪐 Quisiera hacer una consulta sobre los productos de la tienda.';

  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

export function getInstagramUrl(): string {
  return process.env.NEXT_PUBLIC_INSTAGRAM_URL || 'https://www.instagram.com/planetakaioo/';
}
